import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.99 6 0 10l3.99 4v-3H11V9H3.99V6ZM18 4l-3.99-4v3H7v2h7.01v3L18 4Z",
  fill: "#1E92EF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };